import { FuseLoadable } from '@fuse';

export const EmpresaBloqueioConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/empresabloqueio/:motivo',
            component: FuseLoadable({
                loader: () => import('./EmpresaBloqueioApp')
            })
        }
    ]
};
